import * as MicrosoftGraphClient from "@microsoft/microsoft-graph-client";
import axios from 'axios';
import React from 'react';
import { connect } from "react-redux";
import { Link, Redirect } from 'react-router-dom';
import * as ActionType from '././redux/actiontypes/ActionType';
import logo from './assets/images/logo.png';
import * as constants from './Constants';
import environment from './environments/environment';
import LoaderComponent from './LoaderComponent';
import AuthService from './Services/AuthService';


/**
 * The web UI used when Teams pops out a browser window
 */
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: null,
      authInitialized: false,
      userName: '',
      name: '',
      codeValue: [],
      authorityCode: '',
      isLoading: false,
      sessionState: '',
      reDirect: '',
      authorityCode: '',
      isAuthenticated: false,
    }
  }

  componentWillMount = async () => {

    if (AuthService.isLoggedIn()) {
      this.setState({
        isLoading: true,
      });

      this.msGraphClient = MicrosoftGraphClient.Client.init({
        authProvider: async (done) => {
          if (!this.state.accessToken) {
            // Might redirect the browser and not return; will redirect back if successful
            const token = await AuthService.getAccessToken(["User.Read", "Mail.Read"]);
            this.setState({
              accessToken: token
            });
          }
          done(null, this.state.accessToken);
        }
      }
      );
      let user = null;
      this.msGraphClient
        .api("me").get(async (error, userProfile, rawResponse) => {
          if (error === null) {
            const str = {
              ids: [
                environment.azureGroupId
              ]
            };
            user = userProfile;

            this.msGraphClient
              .api('me/checkMemberObjects').post(str, async (error, grpIdArray, rawResponse) => {

                if (error === null) {
                  if (grpIdArray.value.length > 0) {

                    try {
                      this.setState({
                        userName: AuthService.getUsername()
                      })

                      axios.get(environment.getUserDetails + this.state.userName).then(res => {
                        if (res.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                          this.props.dispatch({
                            type: ActionType.LOGIN, userName: user.displayName, emailId: this.state.userName,
                            userAgentApplication: null,
                            accessToken: this.state.accessToken,
                            userRole: res.data.userVOList[0].roles[0].roleName, userId: res.data.userVOList[0].userId,
                            parentId: res.data.userVOList[0].parentId,
                            accessToken: this.state.accessToken, loginIdentity: "web"
                          });
                          this.setState({
                            name: user.displayName
                          })

                          if (res.data !== null && res.data !== undefined) {
                            this.tologinHistory();
                            let path = '/caseSummary';
                            if (this.props.location.state !== undefined) {
                              if (this.props.location.state.pageName === "privacy") {
                                path = "/privacy";
                              } else if (this.props.location.state.pageName === "termsofuse") {
                                path = "/termsofuse";
                              }
                            }
                            this.setState({
                              isLoading: false,
                              isAuthenticated: false,
                              role: res.data.userVOList[0].roles[0].roleName,
                              userId: res.data.userVOList[0].userId,
                              reDirect: path,
                            })
                          }
                        } else {
                          // const cc=MsalNode.                      

                          this.setState({
                            isAuthenticated: true,
                            isLoading: false,
                          })

                        }

                      }, () => {
                        this.setState({
                          isAuthenticated: true,
                          isLoading: false,
                        })
                      });

                    } catch (err) {
                    }
                  } else {
                    this.setState({
                      isAuthenticated: true,
                      isLoading: false,
                    })
                  }

                } else {

                }

              });
          } else {
            this.setState({
              error: error,
              isLoading: false
            });
          }
        }
        );

    }
  }
  componentDidMount = async () => {

  }

  login = e => {
    e.preventDefault();
    if (!AuthService.isLoggedIn()) {
      // Will redirect the browser and not return; will redirect back if successful
      AuthService.login(["User.Read", "Mail.Read", "User.Read.All", "profile"]);

    }

  }

  tologinHistory() {
    let loginHistoryVO = {};
    loginHistoryVO.id = 0;
    loginHistoryVO.name = this.state.name;
    loginHistoryVO.emailId = this.state.userName;
    loginHistoryVO.action = constants.ACTION_LOGIN;
    loginHistoryVO.actionDate = new Date();
    loginHistoryVO.isActive = constants.IS_ACTIVE_YES;
    loginHistoryVO.createdBy = this.state.userName;
    loginHistoryVO.lastUpdatedBy = this.state.userName;
    axios.post(environment.postLoginHistory, loginHistoryVO)
      .then(response => {
        if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
          //  toast.success(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
        } else {
          //  toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
        }
      })
      .catch((error) => {
        //  toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
      });

  }
  logOut = e => {
    e.preventDefault();
    AuthService.logout(this.state.userName);
  }

  render() {
    if (!this.state.isLoading) {
      if (this.state.reDirect) {
        return <Redirect to={this.state.reDirect} />
      }

      return (

        <div className="login-page">
          <div>
            <div>
              <form role="form">
                <div className="form-content">
                  <img name="crt" src={logo} width="400" height="120" style={{ marginLeft: '0px' }} border="0" id="crt" alt="" />
                  <br></br>
                  <Link>
                    <button className="btn rounded  "
                      style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000', borderRadius: '50%' }}
                      onClick={this.login.bind(this)} > Log in </button> </Link>
                  {this.state.isAuthenticated &&
                    <p className='text-danger'>User does not have access to CRT. Please contact the Admin.</p>}
                  {this.state.isAuthenticated &&
                    <p > <Link onClick={this.logOut.bind(this)} >Login with another User</Link>
                    </p>}
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    } else {
      return <LoaderComponent></LoaderComponent>
    }
  }


}

const mapStateToProps = state => {
  return {
    loginInfo: state.loginReducer
  }
};
export default connect(mapStateToProps)(Login);
